import React, { Fragment, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Table from "@/components/common/table";
import { fertigators_listing } from "../../../../tables-columns/fertigators-listing";
import Cookie from "js-cookie";
import axios from "axios";
import AddFertigators from "./AddFertigators/AddFertigators";
import UpdateFertigators from "./AddFertigators/updateFerigatorsForm";
import ConfirmDeleteModal from "components/common/confirm-delete-modal.component";
import { fertigatorServices } from "services/fertigator.services";
import { setAlert } from "@/redux/actions/alert";
import { authServices } from "services/auth.services";
import PageTitle from "@/components/common/page-title.component";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
import ActionButtonsFertigators from "./ActionButtonsFertigators/ActionButtonsFertigators";
export default function Fertigators(props) {
  const { farmsData, suppliersData } = props;
  const { t, i18n } = useTranslation();
  const [showModalFertigators, setShowModalFertigators] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const router = useRouter();
  const SubCategorie = router.query;
  const [org_id, setOrg_id] = useState(null);
  const [dataRow, setDataRow] = useState<any>([]);
  const [rowData, setRowData] = useState<any>({});
  const [page, setpage] = useState(1);

  const tableActions = [
    {
      title: "edit",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("edit")
          ? (setShowUpdateModal(true), setRowData(row.original))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },
    {
      title: "view",
      action(row: any) {},
    },

    {
      title: "delete",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("delete")
          ? (setRowData(row.original), setShowDeleteModal(!showDeleteModal))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },
  ];

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("user"));
    setOrg_id(data?.org_id);
  }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    axios
      .get(
        `fertigators/?org_id__id=${authServices.userValue.org_id}&page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${Cookie.get("token")}`,
          },
        }
      )
      .then((response) => {
        const data = response.data;
        setDataRow(data);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [SubCategorie, showModalFertigators, page]);
  const deleteTrigger = async () => {
    await fertigatorServices
      .deleteFertigator(rowData.id)
      .then((res) => {
        if (res) {
          axios
            .get(
              `fertigators/?org_id__id=${authServices.userValue.org_id}&page=${page}`,
              {
                headers: {
                  Authorization: `Bearer ${Cookie.get("token")}`,
                },
              }
            )
            .then((response) => {
              const data = response.data;
              setDataRow(data);
            })
            .catch((error) => {
              console.log(error.response);
            });
          setShowModalFertigators(false);
          dispatch(
            setAlert({
              message: t("Updated successfully "),
              status: "success",
              priority: "high",
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          setAlert({
            message: t("Somthing went wrong"),
            status: "error",
            priority: "high",
          })
        );
      });
  };
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <div className="w-full">
          <PageTitle
            title={[t("Assets"), t(`fertigators`)]}
            hasLink={true}
            link="/assets"
          />
        </div>
        <ActionButtonsFertigators
          showModalFertigators={showModalFertigators}
          setShowModalFertigators={setShowModalFertigators}
          label={t("Add") + " " + t("fertigators")}
        />
      </div>

      <Table
        fillPage={true}
        columns={fertigators_listing(t)}
        data={dataRow.results ?? []}
        tableAction={tableActions}
        manualPageination={true}
        totalPages={dataRow.total_pages}
        goToPage={(currentPage) => setpage(currentPage)}
        crntpage={page}
      />

      <AddFertigators
        farmsData={farmsData}
        suppliersData={suppliersData}
        showModalFertigators={showModalFertigators}
        setShowModalFertigators={setShowModalFertigators}
        label={"Fertigators"}
      />
      <UpdateFertigators
        farmsData={farmsData}
        suppliersData={suppliersData}
        showModalFertigators={showUpdateModal}
        setShowModalFertigators={setShowUpdateModal}
        label={"Fertigators"}
        rowData={rowData}
        setRowData={setRowData}
      />
      <ConfirmDeleteModal
        id={rowData?.id ?? null}
        setShowModel={setShowDeleteModal}
        showModel={showDeleteModal}
        deleteTrigger={deleteTrigger}
      />
    </div>
  );
}
